import { useState } from 'react'

import { IconImageSquare } from '@vtex/shoreline'

import styles from './styles.module.css'

/** Miniatura do produto: cai no ícone sem URL ou quando a imagem não carrega. */
export const ProductThumb: React.FC<{
  url?: string | null
  className?: string
}> = ({ url, className }) => {
  const [failedUrl, setFailedUrl] = useState<string | null>(null)

  return (
    <span className={className ?? styles.thumb}>
      {url && url !== failedUrl ? (
        <img src={url} alt="" onError={() => setFailedUrl(url)} />
      ) : (
        <IconImageSquare />
      )}
    </span>
  )
}
